import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeScript, SafeStyle, SafeUrl } from '@angular/platform-browser';

@Pipe({
  name: 'decimal'
})
export class DecimalPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }
}
  @Pipe({
    name: 'safe'
  })
  export class SafePipe implements PipeTransform {
  
    constructor(public sanitizer: DomSanitizer) {}
   
   public transform(value: any, type: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
      switch (type) {
        case 'html': return this.sanitizer.bypassSecurityTrustHtml(value);
        // CCR3-11321 Checkmarx Issue Fix 
        
        // case 'style': return this.sanitizer?.bypassSecurityTrustStyle(value) ? this.sanitizer?.bypassSecurityTrustStyle(value) : value;
        // case 'script': return this.sanitizer?.bypassSecurityTrustStyle(value) ? this.sanitizer?.bypassSecurityTrustStyle(value) : value;
        // case 'url': return this.sanitizer?.bypassSecurityTrustStyle(value) ? this.sanitizer?.bypassSecurityTrustStyle(value) : value;
        // case 'resourceUrl': return this.sanitizer?.bypassSecurityTrustStyle(value) ? this.sanitizer?.bypassSecurityTrustStyle(value) : value;
        default: throw new Error(`Invalid safe type specified: ${type}`);
      }
    }
  

}